import { DOMParser } from 'prosemirror-model';
import { EditorState } from 'prosemirror-state';
import { useRef, useState } from 'react';
import plugins from '../plugins';
import defaultSchema from '../schema';
import { EditorView } from 'prosemirror-view';

export const useEditor = (value: string, schema = defaultSchema) => {
  const ref = useRef<{ view: EditorView }>(null);

  const [el] = useState<HTMLDivElement>(() => {
    const el = document.createElement('div');
    el.innerHTML = value;
    return el;
  });

  const [doc, setDoc] = useState(() => DOMParser.fromSchema(schema).parse(el));

  const [state, setState] = useState(() => {
    return EditorState.create({
      schema,
      doc,
      plugins,
    });
  });

  const dispatch = tr => ref?.current?.view?.dispatch(tr);

  const focus = () => ref?.current?.view?.dom['focus']?.();

  return {
    doc,
    setDoc,
    state,
    setState,
    dispatch,
    focus,
    ref,
  };
};
